import { forwardRef, useId } from 'react';
import { Select, type SelectProps } from '../ui/Select';
import { FieldLabel } from './FieldLabel';

export interface SelectFieldProps extends SelectProps {
  required?: boolean;
  optional?: boolean;
  labelVariant?: 'bold' | 'caps';
  /** Figma Step-1 style: label rendered as the empty option instead of above the field. */
  floating?: boolean;
}

/** Select with a visible label above it (or floating label-as-placeholder). */
export const SelectField = forwardRef<HTMLSelectElement, SelectFieldProps>(function SelectField(
  { label, required = false, optional = false, labelVariant = 'caps', floating = false, ...selectProps },
  ref,
) {
  const selectId = useId();
  const placeholder = floating
    ? (selectProps.placeholder ?? `${label}${required ? '*' : ''}`)
    : selectProps.placeholder;

  return (
    <div className="flex flex-col gap-1.5">
      {!floating && (
        <FieldLabel
          label={label}
          htmlFor={selectId}
          required={required}
          optional={optional}
          variant={labelVariant}
        />
      )}
      <Select ref={ref} id={selectId} label={label} {...selectProps} placeholder={placeholder} />
    </div>
  );
});

SelectField.displayName = 'SelectField';
